import { httpGet } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';
import { CalendarResponse, Player } from './types';

export const getActivityCalendar = async (
  players: Player[],
  startDate: Date,
  endDate: Date
): Promise<CalendarResponse> => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/player-activity-calendar`);

  players.forEach((player) => {
    url.searchParams.append('player_ids', `${player.id}`);
  });

  const parsedStart = start.toISOString().split('T')[0];
  const parsedEnd = end.toISOString().split('T')[0];

  url.searchParams.append('start_date', parsedStart);
  url.searchParams.append('end_date', parsedEnd);

  return httpGet(url.toString())
    .then((response) => {
      return response.data.calendar_info as CalendarResponse;
    })
    .catch((error) => {
      throw new Error('Error getting calendar info', error);
    });
};
